import { TeamNamesByID } from '@shared/constants';
import { ITeamStandings } from '@shared/types';
import { ConsoleID, getConsoleState } from 'app/config/Logger';
import { Cls, Emojis } from 'app/constants';
import { setSelectedTeam } from 'app/slices/GamesSlice';
import { store } from 'app/store';

export type ViewTeamLoaderPayload = {
  year: number;
  team: string;
  seasonStandings: ITeamStandings[];
};

const CONSOLE_ON = getConsoleState(ConsoleID.ViewTeamLoader);

export const viewTeamLoader = async ({ params }: any): Promise<ViewTeamLoaderPayload | Response> => {
  const yearId = params.yearId;
  const teamId = params.teamId;

  const msg = `${Emojis.eyes} %c ViewTeamLoader %c yearId %c ${yearId} %c teamId %c ${teamId} %c`;
  if (CONSOLE_ON) console.log(msg, Cls.Loc, '', Cls.Val, '', Cls.Val, '');

  const teamIdNum = parseInt(teamId, 10);
  if (teamIdNum > 0 && teamIdNum <= 32) {
    const teamAbrv = TeamNamesByID[teamId];
    store.dispatch(setSelectedTeam(teamAbrv));
  }

  const seasonStandings: ITeamStandings[] = store.getState().stats.seasonStandings;

  return {
    year: yearId,
    team: teamId,
    seasonStandings,
  };
};
